import React from 'react'
import "./RealWorldEvidence.css"
import PageHeader from '../../components/headers/PageHeader';
import wave from "../../assets/Images/waves/wave_mou.png"
import network from "../../assets/Images/blue_network.png"

export default function RealWorldEvidence() {
  return (
    <div>
      <PageHeader
        mediaSrc={wave}
        mediaType={"image"}
        subtitle={"Enhance Clinical Insight"}
        title={"Real World Evidence"}
      />
      <div className='RWE_Container RWE1'>
        <div className='RWE_Container_1_Img'>
          <img className="RWE_Container_Img_1" src={network} />
        </div>
        <div className='RWE_Container_1'>
          <h2>Leveraging Real World Data for Comprehensive Insights</h2>
          <p>
            Eupraxia leverages Real World Evidence (RWE) to provide deeper insights into how treatments perform in diverse, real-world settings. RWE involves the analysis of data collected outside the controlled environment of clinical trials, such as patient records, health surveys, and claims databases. This approach complements traditional clinical research by offering a broader perspective on treatment effectiveness and safety.
          </p>
        </div>

      </div>
      <div className='RWE_Container RWE2'>
        <h2>Addressing Unmet Medical Needs</h2>
        <hr>
        </hr>
        <br />
        <p>
          By incorporating RWE into our research, we can address questions that are not typically explored in clinical trials, such as long-term outcomes and the impact of treatments on different population groups. This comprehensive understanding aids in making more informed clinical and regulatory decisions, ultimately improving patient care.
        </p>

      </div>
      <div className='RWE_Container RWE3'>
        <h2>Supporting Regulatory and Market Access</h2>
        <br />
        <p>
          Our RWE projects have demonstrated the value of this approach in various therapeutic areas, providing actionable insights that support drug development, regulatory approval, and post-marketing surveillance. From natural history studies and observational studies, to clinical trial planning for every phase of clinical development, our experts can strengthen insights about the quality of your product.
        </p>

      </div>
    </div>

  )
}
